export default () => {
    let destination = "Garden Savvy";

    if (ajax_var.is_iframe || ajax_var.is_affiliate) {
        destination = "Hortisketch";
    }

    if (ajax_var.selected_plan == "hortisketch" || ajax_var.selected_plan == "hortisketch_monthly" || ajax_var.selected_plan == "hortisketch_sfg") {
        destination = "Hortisketch";
    }

    if (ajax_var.selected_plan == "garden_manager") {
        destination = "Garden Manager";
    }

    if (ajax_var.redirect_to && ajax_var.redirect_to.includes("community")) {
        destination = "Community";
    }

    return destination;
};
